//Vimeo
        /*var iframe = document.querySelector('iframe');
        var player = new Vimeo.Player(iframe);
        player.on('pause', function() {
            $('.player-controllers').show();
        });
        player.on('play', function() {
            $('.player-controllers').hide();
        });
        player.on('getEnded', function() {
            $('.player-controllers').show();
        });*/
        $(document).ready(function() {
            $('.testimonial-carousel').owlCarousel({
                items: 3,
                margin: 10,
                loop: true,
                dots: false,
                autoplay: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 3
                    }
                }
            });
            var owl = $('.gallery-carousel').owlCarousel({
                items: 5,
                margin: 20,
                loop: true,
                dots: false,
                autoplay: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 5
                    }
                }
            });
            $('.next-arrow').click(function() {
                owl.trigger('next.owl.carousel');
                return false;
            });
            $('.prev-arrow').click(function() {
                owl.trigger('prev.owl.carousel');
                return false;
            });
            $('.scrollToCTA').click(function() {
                $('html,body').animate({
                    scrollTop: $('.signup-wrapper').offset().top
                }, 700)
            })
            $('.open-popup-link').magnificPopup({
                type: 'inline',
                midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
            });
            $('.video-popup').magnificPopup({
                type: 'iframe',
                midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
            });
            // $('.player-controllers').click(function(){
            //     player.play();
            //     $(this).hide();
            // });
        });
        function makeTimer() {

	//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
		var endTime = new Date("28 November 2019 00:00:00 GMT+01:00");			
			endTime = (Date.parse(endTime) / 1000);

			var now = new Date();
			now = (Date.parse(now) / 1000);

			var timeLeft = endTime - now;

			var days = Math.floor(timeLeft / 86400); 
			var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
			var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
			var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
			if (hours < "10") { hours = "0" + hours; }
			if (minutes < "10") { minutes = "0" + minutes; }
			if (seconds < "10") { seconds = "0" + seconds; }

			$("#time-days").html(days);
			$("#time-hours").html(hours);
			$("#time-minutes").html(minutes);
			$("#time-seconds").html(seconds);		

	}

	setInterval(function() { makeTimer(); }, 1000);

        //Youtube Video
        // 2. This code loads the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
  
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
        // 3. This function creates an <iframe> (and YouTube player)
        //    after the API code downloads.
        var player;
        function onYouTubeIframeAPIReady() {
          player = new YT.Player('player', {
            height: '390',
            width: '640',
            videoId: 'NItrfxhdxAM',
            loop:1,
            autoplay:0,
            events: {
              'onReady': stopVideo,
              'onStateChange': onPlayerStateChange,
              'ended':replayVideo,
              'playerready':onPlayerReady
            }
          });
        }

        function onPlayerReady(event) {
  
            // bind events
            var playButton = document.getElementById("play-button");
            playButton.addEventListener("click", function() {
              player.playVideo();
            });
            
            var pauseButton = document.getElementById("pause-button");
            pauseButton.addEventListener("click", function() {
              player.pauseVideo();
            });
            
          }

        function replayVideo(event){
            event.target.seekTo(0);
        }
        // 4. The API will call this function when the video player is ready.
        function onPlayerReady(event) {
            event.target.stopVideo();
            $('.player-controllers').hide();
        }
  
        // 5. The API calls this function when the player's state changes.
        //    The function indicates that when playing a video (state=1),
        //    the player should play for six seconds and then stop.
        function onPlayerStateChange(event) {
            if (event.data == player.PlayerState.PLAYING) {
                $('.player-controllers').hide();
              }
            
              // If the video is PAUSED, set the onclick element for pause the video.
              // Once the "playButton" is clicked, the video will resume the video = continue playing the video.
              if (event.data == player.PlayerState.PAUSED) {
                $('.player-controllers').show();
              }
        }
        function stopVideo() {
          player.stopVideo();
        }
        $('.player-controllers').click(function(){
            player.playVideo();
            $(this).hide();
        });
        